module.exports = __webpack_public_path__ + "img/eliminate-onboarding-issues.ee2910c1.png";